export default __webpack_public_path__ + "static/media/PJ.bbe34ae3.webp";